// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* dev/52 DR-5 — the phase-aware builder strip inside the chat drawer. */

.Hc8hEmtAyj7Qypl52VVF {
  border-bottom: 1px solid var(--curio-border);
  padding: 10px 16px;
  background: var(--curio-surface-muted);
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.Qd6skRJN9dSuQHnEXZDx {
  display: flex;
  align-items: center;
  gap: 6px;
}

.gGCjYO80ZD35Z0Uh0K2u {
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--curio-text-meta);
  border: 1px solid var(--curio-border);
  border-radius: 999px;
  padding: 2px 10px;
  background: var(--curio-card-bg);
}

.Z4nMrYlbf7XluMkCMgzS {
  color: var(--curio-role-running-fg);
  border-color: var(--curio-role-running-bg);
  background: var(--curio-role-running-bg);
}

.f6DafHOdiJZid21CzC1h {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.QkD7ar3ySAYD7uYZIrVC {
  font-size: 0.74rem;
  border: 1px solid var(--curio-border-strong);
  border-radius: 999px;
  padding: 3px 10px;
  background: var(--curio-card-bg);
  cursor: pointer;
}

.QkD7ar3ySAYD7uYZIrVC:hover {
  background: var(--curio-role-running-bg);
}

.RDW8ymFOTCfXkGzpXVS8 {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.CFQldF1PL7Kb_4ZS3zEn {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.72rem;
  border: 1px solid var(--curio-border);
  border-radius: 6px;
  padding: 2px 8px;
  background: var(--curio-card-bg);
}

.VgcoP_OXfIAo5qwo62fo {
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  color: var(--curio-text-secondary);
}

.w7lQVq5W4HHULNPsf07q { color: var(--curio-text-secondary); }
.VUwpwKZtmsxJdOB9O2Y7 { color: var(--curio-role-running-fg); }
.G3T55FW2R37hA4Bafl86 { color: var(--curio-success-text); }
.te30qFjYK3y4Am51Ramo { color: var(--curio-danger-text); }
.skW2TBXWkypqGC4mhkqg { color: var(--curio-warning-text); }
/* dev/115: the verified loop's live states. */
.pvu5GHHBxxKoP5FeHXdz { color: var(--curio-role-running-fg); }
.KOW5xVGcfMdDD4jAnLkw { color: var(--curio-role-running-fg); font-style: italic; }
.rHXVT9_8TNwXjAG8ssK5 { color: var(--curio-warning-text); }
.gdH9bCfOXi_8_s1JDeQj { color: var(--curio-success-text); font-weight: 600; }
.Ox1yIAkL2UgGk0cQBKrG { color: var(--curio-text-secondary); }
.khEZZIwW9a9zpvK83KBz { color: var(--curio-text-secondary); font-style: italic; }

/* A row out of width moves its next button to a new line; a button keeps its
   label on one (#505). */
.xY84OVUaWTMzR09KzGdv {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.i44AeTNUpguuDX5p2JQC,
.g6N21xP4rd5xopmgG_ML {
  font-size: 0.78rem;
  font-weight: 600;
  border-radius: 8px;
  padding: 5px 14px;
  cursor: pointer;
  border: 1px solid transparent;
  white-space: nowrap;
  flex-shrink: 0;
}

/* Beside a button, the hint takes what is left and wraps inside it. */
.xY84OVUaWTMzR09KzGdv > .DkeqSj68N10biNk44m8k {
  flex: 1 1 0;
  min-width: 0;
}

.i44AeTNUpguuDX5p2JQC {
  background: var(--curio-top-bar-bg);
  color: var(--curio-text-on-dark);
}

.g6N21xP4rd5xopmgG_ML {
  background: var(--curio-card-bg);
  color: var(--curio-success-text);
  border-color: var(--curio-success-bg);
}

.i44AeTNUpguuDX5p2JQC:disabled,
.g6N21xP4rd5xopmgG_ML:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.DkeqSj68N10biNk44m8k,
.eOTJqLytWzumgh8tAFjE {
  font-size: 0.72rem;
}

.DkeqSj68N10biNk44m8k { color: var(--curio-text-meta); }
.eOTJqLytWzumgh8tAFjE { color: var(--curio-danger-text); }

.uDijkJJyBIBPGiVo3qPw {
  font-size: 0.74rem;
  color: var(--curio-text-secondary);
  align-self: center;
  margin-right: 4px;
}

/* dev/131: a node that depends on the USER is visualized as such — the owner's
   "the nodes that depend on user inputs should be better visualized". */
.M9EoQGdUjvPtgrtGUvHM {
    outline: 1px solid var(--curio-warning-text);
    outline-offset: 1px;
    border-radius: 8px;
}

.Hy_j5dZKKUNBqFrLEbYX {
    font-size: 0.66rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: var(--curio-warning-text);
    white-space: nowrap;
}

.JlJbBDW70DeVvWDF7IlK {
    font-size: 0.66rem;
    color: var(--curio-text-secondary);
    white-space: nowrap;
}

/* dev/131: resolve ONE node from its own pill. */
.YuKaRPrsGvWjHL38c1z1 {
    font-size: 0.66rem;
    font-weight: 600;
    border-radius: 6px;
    padding: 1px 6px;
    cursor: pointer;
    border: 1px solid var(--curio-border-strong);
    background: var(--curio-card-bg);
    color: var(--curio-text-primary);
}

.YuKaRPrsGvWjHL38c1z1:hover:not(:disabled) {
    border-color: var(--curio-text-secondary);
}

.YuKaRPrsGvWjHL38c1z1:disabled {
    cursor: default;
    opacity: 0.5;
}
`, "",{"version":3,"sources":["webpack://./src/components/agents/attach/AgentBuilderStrip.module.css"],"names":[],"mappings":"AAAA,wEAAwE;;AAExE;EACE,4CAA4C;EAC5C,kBAAkB;EAClB,sCAAsC;EACtC,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,6BAA6B;EAC7B,qCAAqC;EACrC,oBAAoB;EACpB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,mCAAmC;EACnC,0CAA0C;EAC1C,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,4CAA4C;EAC5C,oBAAoB;EACpB,iBAAiB;EACjB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,2DAA2D;EAC3D,kCAAkC;AACpC;;AAEA,wBAAkB,kCAAkC,EAAE;AACtD,wBAAkB,mCAAmC,EAAE;AACvD,wBAAiB,gCAAgC,EAAE;AACnD,wBAAiB,+BAA+B,EAAE;AAClD,wBAAkB,gCAAgC,EAAE;AACpD,8CAA8C;AAC9C,wBAAqB,mCAAmC,EAAE;AAC1D,wBAAoB,mCAAmC,EAAE,kBAAkB,EAAE;AAC7E,wBAAiB,gCAAgC,EAAE;AACnD,wBAAmB,gCAAgC,EAAE,gBAAgB,EAAE;AACvE,wBAAmB,kCAAkC,EAAE;AACvD,wBAAkB,kCAAkC,EAAE,kBAAkB,EAAE;;AAE1E;yBACyB;AACzB;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,6BAA6B;EAC7B,mBAAmB;EACnB,cAAc;AAChB;;AAEA,sEAAsE;AACtE;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,gCAAgC;EAChC,qCAAqC;AACvC;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA,wBAAQ,6BAA6B,EAAE;AACvC,wBAAS,+BAA+B,EAAE;;AAE1C;EACE,kBAAkB;EAClB,kCAAkC;EAClC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;wEACwE;AACxE;IACI,4CAA4C;IAC5C,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,kCAAkC;IAClC,mBAAmB;AACvB;;AAEA,iDAAiD;AACjD;IACI,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,4CAA4C;IAC5C,gCAAgC;IAChC,gCAAgC;AACpC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,eAAe;IACf,YAAY;AAChB","sourcesContent":["/* dev/52 DR-5 — the phase-aware builder strip inside the chat drawer. */\n\n.strip {\n  border-bottom: 1px solid var(--curio-border);\n  padding: 10px 16px;\n  background: var(--curio-surface-muted);\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.phases {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.phaseChip {\n  font-size: 0.7rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: var(--curio-text-meta);\n  border: 1px solid var(--curio-border);\n  border-radius: 999px;\n  padding: 2px 10px;\n  background: var(--curio-card-bg);\n}\n\n.phaseActive {\n  color: var(--curio-role-running-fg);\n  border-color: var(--curio-role-running-bg);\n  background: var(--curio-role-running-bg);\n}\n\n.templates {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.templateChip {\n  font-size: 0.74rem;\n  border: 1px solid var(--curio-border-strong);\n  border-radius: 999px;\n  padding: 3px 10px;\n  background: var(--curio-card-bg);\n  cursor: pointer;\n}\n\n.templateChip:hover {\n  background: var(--curio-role-running-bg);\n}\n\n.nodeRuns {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.nodeRun {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 0.72rem;\n  border: 1px solid var(--curio-border);\n  border-radius: 6px;\n  padding: 2px 8px;\n  background: var(--curio-card-bg);\n}\n\n.nodeId {\n  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;\n  color: var(--curio-text-secondary);\n}\n\n.status_pending { color: var(--curio-text-secondary); }\n.status_solving { color: var(--curio-role-running-fg); }\n.status_solved { color: var(--curio-success-text); }\n.status_failed { color: var(--curio-danger-text); }\n.status_skipped { color: var(--curio-warning-text); }\n/* dev/115: the verified loop's live states. */\n.status_generating { color: var(--curio-role-running-fg); }\n.status_verifying { color: var(--curio-role-running-fg); font-style: italic; }\n.status_fixing { color: var(--curio-warning-text); }\n.status_verified { color: var(--curio-success-text); font-weight: 600; }\n.status_proposed { color: var(--curio-text-secondary); }\n.status_written { color: var(--curio-text-secondary); font-style: italic; }\n\n/* A row out of width moves its next button to a new line; a button keeps its\n   label on one (#505). */\n.actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.solve,\n.run {\n  font-size: 0.78rem;\n  font-weight: 600;\n  border-radius: 8px;\n  padding: 5px 14px;\n  cursor: pointer;\n  border: 1px solid transparent;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n/* Beside a button, the hint takes what is left and wraps inside it. */\n.actions > .hint {\n  flex: 1 1 0;\n  min-width: 0;\n}\n\n.solve {\n  background: var(--curio-top-bar-bg);\n  color: var(--curio-text-on-dark);\n}\n\n.run {\n  background: var(--curio-card-bg);\n  color: var(--curio-success-text);\n  border-color: var(--curio-success-bg);\n}\n\n.solve:disabled,\n.run:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.hint,\n.error {\n  font-size: 0.72rem;\n}\n\n.hint { color: var(--curio-text-meta); }\n.error { color: var(--curio-danger-text); }\n\n.reviewSummary {\n  font-size: 0.74rem;\n  color: var(--curio-text-secondary);\n  align-self: center;\n  margin-right: 4px;\n}\n\n/* dev/131: a node that depends on the USER is visualized as such — the owner's\n   \"the nodes that depend on user inputs should be better visualized\". */\n.nodeNeedsUser {\n    outline: 1px solid var(--curio-warning-text);\n    outline-offset: 1px;\n    border-radius: 8px;\n}\n\n.needsYou {\n    font-size: 0.66rem;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n    color: var(--curio-warning-text);\n    white-space: nowrap;\n}\n\n.waitingUpstream {\n    font-size: 0.66rem;\n    color: var(--curio-text-secondary);\n    white-space: nowrap;\n}\n\n/* dev/131: resolve ONE node from its own pill. */\n.nodeSolve {\n    font-size: 0.66rem;\n    font-weight: 600;\n    border-radius: 6px;\n    padding: 1px 6px;\n    cursor: pointer;\n    border: 1px solid var(--curio-border-strong);\n    background: var(--curio-card-bg);\n    color: var(--curio-text-primary);\n}\n\n.nodeSolve:hover:not(:disabled) {\n    border-color: var(--curio-text-secondary);\n}\n\n.nodeSolve:disabled {\n    cursor: default;\n    opacity: 0.5;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"strip": `Hc8hEmtAyj7Qypl52VVF`,
	"phases": `Qd6skRJN9dSuQHnEXZDx`,
	"phaseChip": `gGCjYO80ZD35Z0Uh0K2u`,
	"phaseActive": `Z4nMrYlbf7XluMkCMgzS`,
	"templates": `f6DafHOdiJZid21CzC1h`,
	"templateChip": `QkD7ar3ySAYD7uYZIrVC`,
	"nodeRuns": `RDW8ymFOTCfXkGzpXVS8`,
	"nodeRun": `CFQldF1PL7Kb_4ZS3zEn`,
	"nodeId": `VgcoP_OXfIAo5qwo62fo`,
	"status_pending": `w7lQVq5W4HHULNPsf07q`,
	"status_solving": `VUwpwKZtmsxJdOB9O2Y7`,
	"status_solved": `G3T55FW2R37hA4Bafl86`,
	"status_failed": `te30qFjYK3y4Am51Ramo`,
	"status_skipped": `skW2TBXWkypqGC4mhkqg`,
	"status_generating": `pvu5GHHBxxKoP5FeHXdz`,
	"status_verifying": `KOW5xVGcfMdDD4jAnLkw`,
	"status_fixing": `rHXVT9_8TNwXjAG8ssK5`,
	"status_verified": `gdH9bCfOXi_8_s1JDeQj`,
	"status_proposed": `Ox1yIAkL2UgGk0cQBKrG`,
	"status_written": `khEZZIwW9a9zpvK83KBz`,
	"actions": `xY84OVUaWTMzR09KzGdv`,
	"solve": `i44AeTNUpguuDX5p2JQC`,
	"run": `g6N21xP4rd5xopmgG_ML`,
	"hint": `DkeqSj68N10biNk44m8k`,
	"error": `eOTJqLytWzumgh8tAFjE`,
	"reviewSummary": `uDijkJJyBIBPGiVo3qPw`,
	"nodeNeedsUser": `M9EoQGdUjvPtgrtGUvHM`,
	"needsYou": `Hy_j5dZKKUNBqFrLEbYX`,
	"waitingUpstream": `JlJbBDW70DeVvWDF7IlK`,
	"nodeSolve": `YuKaRPrsGvWjHL38c1z1`
};
export default ___CSS_LOADER_EXPORT___;
